module.exports = __webpack_public_path__ + "img/gear-wheel.2318dcd8.png";